var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.774 9.168a.75.75 0 011.056 1.056l-.052.056L15.06 12l1.72 1.719.05.056a.75.75 0 01-1.055 1.055l-.056-.05-1.72-1.72-1.718 1.72-.057.05a.75.75 0 01-1.054-1.055l.05-.056 1.72-1.719-1.72-1.719-.051-.056a.75.75 0 011.055-1.056l.057.052L14 10.938l1.719-1.718.056-.052z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4a1 1 0 011 1v14a1 1 0 01-1 1H9.454l-.108-.006a1 1 0 01-.645-.336l-6.125-7a1 1 0 010-1.316l6.125-7a1 1 0 01.645-.336L9.454 4H21zM3.992 12l5.688 6.5H20.5v-13H9.68L3.992 12z",
    fill: "currentColor"
  })));
}
SvgDelete.displayName = 'Delete';
export default SvgDelete;